import styled from "styled-components"

export const Links = styled.div`
  padding: 1.2rem 2.4rem;
`

export default Links
